<template>
  <div class="ship-vetting-container">
    <!-- DISCLAIMER POPUPS -->
    <ShipVettingDisclaimer
      v-if="currentDisclaimer"
      :key="currentDisclaimer.id"
      :status="currentDisclaimer.status"
      :badge-count="disclaimers.length"
      :vessel-name="currentDisclaimer.vesselName"
      :date-time="currentDisclaimer.dateTime"
      @disclaimer-confirmed="handleConfirm"
    />

    <transition name="fade-transform" mode="out-in">
      <div v-if="pageStatus == 0">
        <ShipVettingList class=" barging-container"></ShipVettingList>
      </div>
      <div v-if="pageStatus == 1 || pageStatus == 2">
        <ShipVettingDetail class="top2"></ShipVettingDetail>
      </div>
  </transition>
  </div>
</template>

<script>
import ShipVettingDisclaimer from './common/ShipVettingDisclaimer.vue'
import tabs from "@/components/tabs.vue";
import PdfView from "@/components/common/pdf-view.vue";
import { mapState } from "vuex";
import ShipVettingDetail from './component/detail.vue'
import ShipVettingList from './component/list.vue'
import { getUnseenDisclaimers, updateDisclaimerSeen } from '@/services'
export default {
  name: "ShipVetting",
  components: { ShipVettingDisclaimer, tabs, PdfView, ShipVettingList, ShipVettingDetail },
  watch: {
    // '$route' (to, from) {
    //     this.$router.go(0);
    // },
    "$route.query": {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (this.$route.query.pageStatus) {
          this.pageStatus = this.$route.query.pageStatus
        }else{
          this.pageStatus= 0
        }
      },
    },
    locale() {
      this.refresh = false;
      this.$nextTick(() => {
        this.refresh = true;
      });
    },
    pageStatus(){
    }
  },
  data() {
    return {
      pageStatus: 0,
      disclaimers: [],
      currentDisclaimer: null,
      upIndex: 0,
    };
  },
  computed: {
    ...mapState(["locale","userInfo","screenType"]),
    isMobileScreen(){
      return this.screenType?.isMobileScreen??false;
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.$refs.orderListRef) {
      this.$refs.orderListRef.handleStopRefresh()
    }
    if (!to.path.startsWith("/ship-vetting")) {
      window.localStorage.removeItem("shipVettingCompanyStatus");
    }
    next()
  },
  created() {
  },
  methods: {
    // load the pending disclaimers
    async fetchDisclaimers() {
      try {
        const resp = await getUnseenDisclaimers();
        this.disclaimers = Array.isArray(resp.data)
          ? resp.data
          : [];
        this.currentDisclaimer = this.disclaimers.shift() || null;
      } catch (err) {
        console.error('Failed loading disclaimers', err);
      }
    },

    // user clicked “Confirm” on the dialog
    async handleConfirm() {
      if (!this.currentDisclaimer) return;
      try {
        await updateDisclaimerSeen(this.currentDisclaimer.id);
        this.currentDisclaimer = this.disclaimers.shift() || null;
        await this.$store.dispatch("fetchShipVettingCount");
      } catch (err) {
        console.error('Failed to confirm disclaimer', err);
      }
    },
  },
  mounted() {
    this.fetchDisclaimers();
  },
};
</script>

<style scoped lang="scss">
.top {
  // height: 100vh;
  // position: relative;
  // width: 100%;
  height: calc(100vh - 90px);
  // overflow: hidden;
  // box-sizing: border-box;
}
</style>
